// extracted by mini-css-extract-plugin
export default {"page":"Favorites_page__DEukr","favorites":"Favorites_favorites__Bj7Zi","delete":"Favorites_delete__vNRAM"};